var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7444 8.44057C15.7444 12.6599 12.324 16.0804 8.10463 16.0804C3.88528 16.0804 0.464844 12.6599 0.464844 8.44057C0.464844 4.22122 3.88528 0.800781 8.10463 0.800781C12.324 0.800781 15.7444 4.22122 15.7444 8.44057Z",
    fill: "#FFA143"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55727 8.75959C5.55727 9.63862 4.84468 10.3512 3.96565 10.3512C3.08661 10.3512 2.37402 9.63862 2.37402 8.75959C2.37402 7.88056 3.08661 7.16797 3.96565 7.16797C4.84468 7.16797 5.55727 7.88056 5.55727 8.75959Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0133 8.75959C10.0133 9.63862 9.30073 10.3512 8.4217 10.3512C7.54267 10.3512 6.83008 9.63862 6.83008 8.75959C6.83008 7.88056 7.54267 7.16797 8.4217 7.16797C9.30073 7.16797 10.0133 7.88056 10.0133 8.75959Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4704 8.75959C14.4704 9.63862 13.7578 10.3512 12.8787 10.3512C11.9997 10.3512 11.2871 9.63862 11.2871 8.75959C11.2871 7.88056 11.9997 7.16797 12.8787 7.16797C13.7578 7.16797 14.4704 7.88056 14.4704 8.75959Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.1156caa9ae40236add1c4e11000f2ccb.svg";
export { ForwardRef as ReactComponent };